import { putTagManager } from '../api/tagManager';
export const updatePerson = async ({ personId, name, faceId, fileChecksum, }, logger) => {
    const urlParams = new URLSearchParams();
    name && urlParams.append('name', name);
    faceId && urlParams.append('faceId', faceId);
    fileChecksum && urlParams.append('fileChecksum', fileChecksum);
    return putTagManager(`person/${personId}?${urlParams.toString()}`, {}, logger);
};
